/**
 * Created by Alex Aguilar on 7/6/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('adminFlightList',{
                parent: 'app',
                url: '/adminFlightList?date&model',
                params: {
                    date: "" + (new Date()).getTime() + "",
                    model: "all"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminFlight/adminFlight/list/adminFlightList.html',
                        controller: 'adminFlightListCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('adminFlights')
                            }],
                            'modelAircraftFlights': ['modelAircraftService', '$stateParams',
                                function(modelAircraftService, $stateParams){
                                    if($stateParams.date != null && $stateParams.model == "all"){
                                        return modelAircraftService.getModelAircraftFlights(parseInt($stateParams.date))
                                    }else{
                                        return null;
                                    }
                            }],
                            'modelAircrafts': ['modelAircraftService', function(modelAircraftService){
                                return modelAircraftService.getModelAircrafts()
                            }],
                            'aircraftFlights': ['aircraftService', '$stateParams', function(aircraftService, $stateParams){
                                if($stateParams.date != ""){
                                    return aircraftService.getAircraftFlights(parseInt($stateParams.date))
                                }else{
                                    return [];
                                }

                            }]
                        }
                    }
                }
            });
    }
})();


